import { Component } from 'react';
import Form from './Form.js';
import Preview from './Preview.js';
import LimitInfo from './LimitInfo.js';
import './Main.scss';
import Fetch from '../lib/Fetch.js';
import Cookie from '../lib/Cookie.js';
import LocalStorage from "../lib/LocalStorage.js";

class Main extends Component {
	constructor(props) {
		super(props);
		this.state = {
			url: '',
			markup: '',
			markupSrc: '',
			title: '',
			titleTranslated: '',
			descr: '',
			descrTranslated: '',
			keywords: '',
			keywordsTranslated: '',
			brand: LocalStorage.getItem('snippet-preview-brand') || '',
			rating: false,
			date: false,
			loggedIn: false,
			language: LocalStorage.getItem('snippet-preview-language') || window?.t?.DEFAULT_LANGUAGE_NAME,
			translationLanguage: LocalStorage.getItem('snippet-preview-translation-language') || '',
			logoutLink: '',
			user: {},
			limits: {},
			limitUsage: {},
			planName: '',
		}

		this.setData = this.setData.bind(this);
		this.updateLimitUsage = this.updateLimitUsage.bind(this);
	}

	setData(field, value) {
		let data = {};
		data[field] = value;
		this.setState(data);
		const inLs = ['language', 'brand'];
		if (inLs.includes(field)) {
			LocalStorage.setItem('snippet-preview-' + field, value);
		}
	}

	async componentDidMount() {
		const urlParams = new URLSearchParams(window.location.search);
		const forceFree = urlParams.get('free') || false;
		const payload = {};
		if (forceFree) {
			payload.free = true;
		}

		const data = await Fetch.post(`https://${window.location.hostname}/tools/snippet-preview/ajax/session.php`, payload);
		if (!data) {
			this.setState({
				loggedIn: false
			});
			return;
		};
		let limits = data.planData.limits
		? {
			daily: data.planData.limits.daily ? data.planData.limits.daily['snippet-preview'] : 0,
			monthly: data.planData.limits.monthly ? data.planData.limits.monthly['snippet-preview'] : 0,
			permanent: data.planData.limits.permanent ? data.planData.limits.permanent['snippet-preview'] : 0,
		} : {
			daily: 3,
		}
		this.setState({
			loggedIn: !!data.loggedIn,
			user: data.user || {},
			logoutLink: data.logoutLink || '',
			limitUsage: data.loggedIn ? data.limitUsage : this.getDailyLimitUsage(),
			limits: limits,
			permissions: data.planData && data.planData.permissions ? data.planData.permissions : [],
			planName: data.planName || 'free',
		});
	}

	getDailyLimitUsage() {
		let cookieValue = parseInt(Cookie.get('snippet-preview-usage')) || 0;
		return {
			daily: cookieValue,
		}
	}

	async updateLimitUsage(limitName) {
		const limits = ['snippet-preview'];
		const newState = {};
		if (this.state.limits.daily) {
			limits.push('daily-' + limitName);
		}
		if (this.state.limits.monthly) {
			limits.push('monthly-' + limitName);
		}
		if (this.state.limits.permanent) {
			limits.push('permanent-' + limitName);
		}

		if (this.state.user.id) {
			const result = await Fetch.post(`https://${window.location.hostname}/tools/snippet-preview/ajax/update-limit-usage.php`, {
				uid: this.state.user ? this.state.user.id : false,
				plan: this.state.user.plan,
				credits: this.state.user.credits,
				limits: limits,
			});

			if (result.status === 'ok') {
				let updatedUser = this.state.user;
				updatedUser.credits = result.credits;
				newState.user = updatedUser;

				if (result.limitUsage) {
					const newLimitUsage = {
						daily: result.limitUsage['daily-snippet-preview'],
						monthly: result.limitUsage['monthly-snippet-preview'],
						permanent: result.limitUsage['permanent-snippet-preview'],
					}
					newState.limitUsage = newLimitUsage;
				}
			}

			this.setState(newState);

			return result;
		}

		let limitUsage = parseInt(Cookie.get('snippet-preview-usage')) || 0;
		if (limitUsage && limitUsage >= this.state.limits.daily) {
			return {
				status: 'error',
			}
		}

		limitUsage ++;
		Cookie.set('snippet-preview-usage', limitUsage.toString());
		this.setState({
			limitUsage: {
				daily: limitUsage,
			}
		});
		return {
			status: 'ok',
		}
	}

	render() {
		const {user, logoutLink, loggedIn, limits, limitUsage, permissions, planName, translationLanguage, descrTranslated, titleTranslated} = this.state;
		let userInfo = '';

		const hasTranslation = translationLanguage && descrTranslated && titleTranslated;

		const urlParams = new URLSearchParams(window.location.search);
		const iframe = urlParams.get('iframe');
		const free = urlParams.get('free');
		if (loggedIn && iframe && !free) {
			userInfo = (<p class="user-info"><b class="user-email">{user.name}</b> <a href={logoutLink}>{window?.t?.LOG_OUT}</a></p>);
		}
		let limitInfo = '';
		if (!user || this.state.user.plan === 'free') {
			limitInfo = <LimitInfo
			dailyUsage={limitUsage.daily}
			dailyLimit={limits.daily}
			monthlyUsage={limitUsage.monthly}
			monthlyLimit={limits.monthly}
			permanentUsage={limitUsage.permanent}
			permanentLimit={limits.permanent}
			planName={planName}
			credits={user.credits}
			/>
		}
		let isDailyLimitUsed = limits.daily && limitUsage.daily >= limits.daily;
		let isMonthlyLimitUsed = limits.monthly && limitUsage.monthly >= limits.monthly;
		let isPermanentLimitUsed = limits.permanent && limitUsage.permanent >= limits.permanent;
		let isAnyLimitUsed = isDailyLimitUsed || isMonthlyLimitUsed || isPermanentLimitUsed;
		return (
			<>
			{userInfo}
			{limitInfo}
			<div className="tool">
				<Form
					changeCallback={this.setData}
					url={this.state.url}
					markup={this.state.markup}
					markupSrc={this.state.markupSrc}
					title={this.state.title}
					descr={this.state.descr}
					brand={this.state.brand}
					keywords={this.state.keywords}
					language={this.state.language}
					translationLanguage={this.state.translationLanguage}
					rating={this.state.rating}
					date={this.state.date}
					isAppsumo={user.appsumo}
					isPro={permissions && permissions.includes('snippet-preview-ai')}
					langDetection={permissions && permissions.includes('snippet-preview-lang-detect')}
					isLimitUsed={isAnyLimitUsed}
					updateLimitUsage={this.updateLimitUsage}
				 />
				 <div className="preview">
				<Preview
					url={this.state.url || '#'}
					title={this.state.title || window?.t?.DEFAULT_TITLE}
					descr={this.state.descr || window?.t?.DEFAULT_DESCRIPTION}
					keywords={this.state.keywords}
					brand={this.state.brand}
					rating={this.state.rating}
					date={this.state.date}
					changeCallback={this.setData}
				/>
				{hasTranslation ? (
					<>
					<h2>{window?.t?.TRANSLATED_SNIPPET_TITLE}</h2>
					<Preview
						url={this.state.url || '#'}
						title={this.state.titleTranslated || ''}
						descr={this.state.descrTranslated || ''}
						keywords={this.state.keywordsTranslated}
						brand={this.state.brand}
						rating={this.state.rating}
						date={this.state.date}
					/>
					</>
				) : ''}
				</div>
			</div>
			</>
		)
	}

	dateFromTimestamp(timestamp) {
		const date = new Date(timestamp);
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
		return `${year}${month}${day}`;
	}
}

export default Main;